<template>
    <div>
        <div class="collapsible" :class="{opened: !submitting && !submitted}">
            <Alert :alert="alert"/>

            <TextField type="email" v-model="email" label="Informe seu email e avisaremos quando estiver disponível:"
                        placeholder="Email" :error="emailError"/>

            <template v-if="!isProductSingleSize">
                <ProductVariationsOld
                    :product="product"
                    v-model="sizeToReprint"
                    label="Informe o tamanho desejado:" :reprint-mode="true"
                    class="frame-outline mt"/>
            </template>

            <Checkbox v-model="subscribeNewsletter" id="reprint-newsletter" class="mt"
                      label="Também quero receber informações sobre promoções e lançamentos em meu email"/>

            <button class="btn btn-wide btn-lg mt" @click="sendReprint" :disabled="!sizeToReprint">
                Enviar
            </button>
        </div>

        <div class="collapsible" :class="{opened: submitting}">
            <div class="alert">
                <div class="d-flex flex-spaced-fixed">
                    <div class="cr-spinner-small"></div>
                    <p>Aguarde...</p>
                </div>
            </div>
        </div>

        <div class="collapsible" :class="{opened: submitted}">
            <p class="alert-success">
                Obrigado, você será avisado quando este produto voltar ao estoque.
            </p>

            <button @click="$emit('done')" class="btn btn-wide">Ok</button>
        </div>
    </div>
</template>

<script>
    import Alert from "../common/Alert";
    import {productService} from "../../../common/resource";
    import ProductVariationsOld from "./ProductVariationsOld";
    import {productStore} from "../../common/store/product-store";
    import Checkbox from "@bit/chicorei.chicomponents.input.checkbox";
    import TextField from "@bit/chicorei.chicomponents.input.text-field"
    import SelectField from "@bit/chicorei.chicomponents.input.select-field";

    export default {
        name: "ProductReprint",

        components: {ProductVariationsOld, SelectField, TextField, Checkbox, Alert},

        data() {
            return {
                productStoreState: productStore.state,

                email: this.$scope.CUSTOMER ? this.$scope.CUSTOMER.EMAIL : null,
                subscribeNewsletter: false,

                alert: null,
                emailError: null,

                submitting: false,
                submitted: false,
            }
        },

        computed: {
            product() {
                return this.productStoreState.product;
            },

            isProductSingleSize() {
                return this.productStoreState.isProductSingleSize;
            },

            sizeToReprint: {
                get() {
                    return this.productStoreState.sizeToReprint
                },

                set(val) {
                    this.productStoreState.sizeToReprint = val
                }
            },
        },

        mounted() {
            if (this.isProductSingleSize) {
                this.sizeToReprint = this.product.variations[0];
            }
        },

        methods: {
            validate() {
                if (!this.sizeToReprint) {
                    this.alert = {
                        message: 'Selecione um tamanho',
                        isError: true
                    };

                    return false;
                }

                if (!this.email) {
                    this.emailError = 'Informe seu email';
                    return false;
                }

                return true;
            },

            sendReprint() {
                if (!this.validate()) return;

                this.submitting = true;
                productService.requestReprint(this.product.id, this.sizeToReprint.variation_id, {
                    email: this.email,
                    optIn: this.subscribeNewsletter
                }).then(() => {
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'addToReprint',
                            product_gender: this.sizeToReprint.gender,
                            product_size: this.sizeToReprint.size_name
                        });
                    }

                    this.submitted = true;
                }).catch(data => this.showError(data.response))
                    .then(() => this.submitting = false);
            },

            showError(response) {
                this.alert = {
                    message: 'Não foi possível enviar os dados.',
                    isError: true
                };

                if (response.data.errors.email) {
                    this.emailError = response.data.errors.email[0];
                }
            },
        },
    }
</script>